import { createSharedComposable } from '@vueuse/core'
import { reactive, ref } from 'vue'

type PaymentStatus = 'loading' | 'success' | 'error'

type OpenPayload = {
  amount: number
  cancellable: boolean
  onCancel?: () => void
}

export const usePaymentWaitingScreen = createSharedComposable(() => {
  const state = reactive({
    visible: false,
    amount: 0,
    cancellable: false,
    status: 'loading' as PaymentStatus,
    errorMessage: ''
  })

  const cancelCallback = ref<(() => void) | null>(null)

  function open({ amount, cancellable, onCancel }: OpenPayload) {
    state.visible = true
    state.amount = amount
    state.cancellable = cancellable
    state.status = 'loading'
    state.errorMessage = ''
    cancelCallback.value = onCancel ?? null
  }

  function close() {
    state.visible = false
    state.amount = 0
    state.cancellable = false
    state.status = 'loading'
    state.errorMessage = ''
    cancelCallback.value = null
  }

  function setSuccess() {
    state.status = 'success'
    state.cancellable = false
  }

  function setError(message?: string) {
    state.status = 'error'
    state.cancellable = false
    state.errorMessage = message || ''
  }

  function triggerCancel() {
    cancelCallback.value?.()
  }

  return {
    state,
    open,
    close,
    setSuccess,
    setError,
    triggerCancel
  }
})
